/* eslint-disable no-underscore-dangle, global-require */
import React from 'react';
import { createRoot } from 'react-dom/client';

import ChannelFollowers from './ChannelFollowers';

// Element on which component will be mounted
const MOUNT_ELEMENT = document.getElementById('channel-follow');

// Allow passing context from template
const context = window.__VUMEDI_REACT_CONTEXT__;

if (MOUNT_ELEMENT) {
    createRoot(MOUNT_ELEMENT).render(<ChannelFollowers {...context} />);
}
